<template>
  <v-app>
    <v-app-bar
        app
      color="primary"
      dark
      flat
      dense
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-app-bar-title class="font-weight-light" style="min-width: 160px">
        <span class="font-weight-bold">OCC</span>
        <span class="success--text">GROUND</span>
      </v-app-bar-title>

      <v-spacer></v-spacer>


        <div class="text-truncate">
          <div class="text-right">{{now | moment('HH:mm')}}</div>
          <div class="d-inline-block">
            <div v-if="user">
              <v-icon small>person</v-icon>
              <span class="text-caption text-sm-body-1">{{tlc}}</span>
            </div>
            <v-btn
                v-if="!oidcIsAuthenticated"
                outlined
                x-small
                @click="authenticateOidc"
            >
              Login with ADFS
            </v-btn>
          </div>
        </div>





    </v-app-bar>
    <v-navigation-drawer
        v-model="drawer"
        absolute
        temporary
    >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">
            Events
          </v-list-item-title>
          <v-list-item-subtitle>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list
          dense
          nav
      >
          <v-list-item
              v-for="mi in menu"
              :to="mi.to"
              :key="mi.to"
          >
            <v-list-item-avatar>
              <v-icon>{{ mi.icon }}</v-icon>
            </v-list-item-avatar>
            {{ mi.title }}
          </v-list-item>
      </v-list>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">
            Flights
          </v-list-item-title>
          <v-list-item-subtitle>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list
          dense
          nav
      >
        <v-list-item to="/flights/search">
          <v-list-item-avatar>
            <v-icon>search</v-icon>
          </v-list-item-avatar>
          Search
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-main style="padding-top: 45px">
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex'
import jwtDecode from 'jwt-decode'

export default {
  name: 'App',
  components: {},
  data: () => ({
    drawer: false,
    menu: [
      {icon: 'list', title: 'All', to: '/events/all'},
      {icon: 'north_east', title: 'Departures', to: '/events/dep'},
      {icon: 'south_east', title: 'Arrivals', to: '/events/arr'},
      {icon: 'star', title: 'Starred', to: '/events/starred'},
      {icon: 'mdi-map-marker-outline', title: 'By stand', to: '/events/stand'},
    ]
  }),
  methods: {
    ...mapActions({
      'updateFilter': 'arrivalsAndDepartures/updateFilter',
      'removeOidcUser': 'oidcStore/removeOidcUser',
      'authenticateOidc': 'oidcStore/authenticateOidc',
      'authenticateOidcSilent': 'oidcStore/authenticateOidcSilent',
      'start': 'start',
    }),
    userLoaded: function (e) {
      if (e.detail.access_token) {
        const claims = jwtDecode(e.detail.access_token)
        if (claims.group) {
          this.$store.dispatch('setRoles', claims.group)
        }
      }
    },
    oidcError: function (e) {
      console.log('I am listening to the oidc error event in vuex-oidc', e.detail)
    },
  },
  created() {
    this.start()
  },
  mounted() {
    window.addEventListener('vuexoidc:userLoaded', this.userLoaded)
    window.addEventListener('vuexoidc:oidcError', this.oidcError)
  },
  destroyed() {
    window.removeEventListener('vuexoidc:userLoaded', this.userLoaded)
    window.removeEventListener('vuexoidc:oidcError', this.oidcError)
  },
  computed: {
    ...mapState({
      now: state => state.app.now,
      itemsFilter: state => state.arrivalsAndDepartures.filter,
      roles: state => state.app.roles
    }),
    ...mapGetters('oidcStore', [
      'oidcIsAuthenticated',
      'oidcAuthenticationIsChecked',
      'oidcUser',
      'oidcIdToken',
      'oidcIdTokenExp'
    ]),
    filter: {
      get() {
        return this.itemsFilter
      },
      set(value) {
        this.updateFilter(value)
      }
    },
    tlc() {
      return this.user && this.user.upn ? (this.user.upn.length <= 3 ? this.user.upn : this.user.upn.substring(0, 3)) : ''
    },
    user() {
      return this.oidcUser
    }
  },
};
</script>
